





























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { regionService } from '@/services/RegionService';
import { workspaceService } from '@/services/WorkspaceService';
import { storeService } from '@/services/StoreService';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class InfoBar extends Vue {
  isMenuOpen = false;
  workspaceId = 0;
  regionId: any = 0;
  limits: any = {
    cpu_cores: 0,
    ram: 0,
    storage: 0,
    public_networks: 0,
  };
  currentUsage: any = {
    cpu_cores: 0,
    ram: 0,
    storage: 0,
    public_networks: 0,
  };
  activeRegions = [];
  inactiveRegions = [];
  isModalShown = false;
  subject: any = 'resources';
  formDescription: any = '';
  errors: any = [];
  isMailSendSuccessfully = false;
  currentRegion = {
    id: 0,
    name: '',
    full_name: '',
    active: true,
  };
  progress: any = {};
  increaseLimits: any = {};
  isLoading = false;
  isLoadingLimits = true;
  isLoadingUsage = true;

  @Watch('$route.params.regionId')
  onRegionChange() {
    this.update();
    this.getLimits();
  }

  @Watch('$store.state.currentWorkspace.limits', { immediate: true, deep: true })
  onLimitsChange(data: any) {
    this.limits = data;
    this.isLoadingLimits = false;
    this.updateBars();
  }

  @Watch('$store.state.currentWorkspace.currentUsage', { immediate: true, deep: true })
  onUsageChange(data: any) {
    this.currentUsage = data;
    this.isLoadingUsage = false;
    this.updateBars();
  }

  @Watch('$store.state.regions.regions', { immediate: true, deep: true })
  onRegionsChange() {
    this.isLoadingLimits = true;
    this.isLoadingUsage = true;
    const data = this.$store.state.regions.regions;
    if (!data || !data.length) {
      return;
    }
    this.activeRegions = data.filter((item: any) => item.active);
    this.inactiveRegions = data.filter((item: any) => !item.active);
    if (this.regionId) {
      const matchingRegions = data.filter((item: any) => item.id === this.regionId);
      if (matchingRegions.length) {
        this.currentRegion = matchingRegions[0];
      }
    }
    if (!this.currentRegion.id) {
      const matchingRegions = data.filter((item: any) => item.id === this.regionId);
      if (matchingRegions.length) {
        this.currentRegion = matchingRegions[0];
      } else if (this.activeRegions.length) {
        this.currentRegion = this.activeRegions[0];
      } else if (this.inactiveRegions.length) {
        this.currentRegion = this.inactiveRegions[0];
      }
    }
    storeService.getLimits();
    storeService.getCurrentUsage();
  }

  mounted() {
    this.isLoadingLimits = true;
    this.isLoadingUsage = true;
    document.addEventListener('click', () => {
      this.isMenuOpen = false;
    });
    this.$root.$on('update-regions', () => {
      this.update();
    });
    this.update();
    this.formDescription = this.$t('helpForm.descriptions.resources');
    this.getLimits();
  }

  onClose() {
    this.errors = [];
    this.isMailSendSuccessfully = false;
    this.formDescription = this.$t('helpForm.descriptions.resources');
    this.isModalShown = false;
  }
  update() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    if (!this.workspaceId) {
      return;
    }
    storeService.getRegions();
  }
  getLimits() {
    storeService.getLimits();
    storeService.getCurrentUsage();
  }

  updateBars() {
    this.increaseLimits = {};
    ['cpu_cores', 'ram', 'storage', 'public_networks'].map(item => {
      if ((100 * this.currentUsage[item]) / this.limits[item] > 80) {
        this.increaseLimits[item] = true;
      }
      this.progress[item] = ((100 * this.currentUsage[item]) / this.limits[item]).toString();
    });
  }

  send() {
    this.errors = [];
    if (!this.formDescription) {
      this.errors.push(this.$t('scripts.descriptionIsRequired'));
    }
    if (this.formDescription && this.formDescription.length < 10) {
      this.errors.push(this.$t('scripts.descriptionIsTooShort'));
    }
    if (this.errors.length) {
      return;
    }
    const data = new FormData();
    data.append('type', this.subject);
    data.append('description', this.formDescription);
    data.append('region_id', this.regionId);
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    workspaceService
      .createTicket(this.workspaceId, data)
      .then(() => {
        this.isLoading = false;
        this.isMailSendSuccessfully = true;
      })
      .catch(() => {
        this.isLoading = false;
        this.isMailSendSuccessfully = false;
      });
  }
}
